import { render, staticRenderFns } from "./chip-primary4.vue?vue&type=template&id=7cf53bd8&scoped=true&"
import script from "./chip-primary4.vue?vue&type=script&lang=js&"
export * from "./chip-primary4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf53bd8",
  null
  
)

export default component.exports